import React from 'react';
import { string } from 'prop-types';
import { StatusMessage } from '@tesla/design-system-react';
import { useIntl } from 'react-intl';
import messages from './messages';
import style from '../../containers/JobApplication/style.module.scss';

const Error = ({ heading, copy }) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const errorHeading = heading || formatMessage(messages.ErrorMessageHeader);
  const errorCopy = copy || formatMessage(messages.ErrorMessage);

  return (
    <div className={`tds-layout tds-layout--constrained ${style.FormLayout}`}>
      <div className={style.FormLayoutItem}>
        <StatusMessage body={errorCopy} header={errorHeading} type="error" enclosed={false} />
      </div>
    </div>
  );
};

Error.propTypes = {
  copy: string,
  heading: string,
};

Error.defaultProps = {
  copy: null,
  heading: null,
};

export default Error;
